// import "./SignUp.scss";
import "../../assets/sass/components/signUp/_signUp.scss";
import "../../assets/sass/components/signIn/_signIn.scss";

import React, { useEffect, useRef, useState } from "react";
// import { Formik } from "formik";
import * as Yup from "yup";
import { Trans, useTranslation } from "react-i18next";
import debounce from "lodash/debounce";

import GLOBAL from "../../global";
// import LogoPng from "../../assets/img/logo/logo.png";
import { getUserIdentification } from "../../utils/Utils";
import PasswordStrengthChecker from "./PasswordStrengthChecker";
import authService from "../../services/AuthService";
import leftIcon from "../../assets/img/signin/leftIcon.svg";
import doctorIcon from "../../assets/img/signin/doctor-icon.svg";
import topRoundIcon from "../../assets/img/signin/topRound.svg";
import mmhColorLogo from "../../assets/img/signin/mmhLogo.svg";
import bottomRoundIcon from "../../assets/img/signin/bottomRound.svg";
import { useLocation, useHistory } from "react-router-dom";
import routes from "../../constants/Routes";
import useForm from "../../hooks/useForm";
import { toast } from "react-toastify";
import VerifyInvitationDto from "./dto/VerifyInvitationDto";
import AnswerValidationService from "../../services/answerValidation/AnswerValidationService";
import answerValidationMessagesConstant from "../../services/answerValidation/answerValidationMessagesConstant";
import {
    answerValidationRuleForSpecificQuestionId
} from "../../services/answerValidation/answerValidationRuleForSpecificQuestionId";
import CONSTANT from "../../constants/Constant";
import PackageSmallDetails from "../package/PackageSmallDetails";
import useD2C from "../../hooks/useD2C";
import { useHandleDirectPayment } from "../../contexts/DirectPaymentContext";
import MaskInput from "../shared/form-element/MaskInput";
import { setEventData } from "../../features/askEmma/askEmmaSlice";
import { useDispatch } from "react-redux";
import InputMask from "react-input-mask";
import { useTenantFeatures } from "../../features/tenantFeatures/useTenantFeature";

const USER_STATUS = Object.freeze({
    REGISTERED: 1,
    INVITED: 2,
    NOT_FOUND: 3,
    D2C_REGISTRATION: 4
});

function SignUp1(props) {
    const { onSubmitSignUp, invalidFormElement, onClickTermOfServiceToggle, signUpCreated, errorMessage, setErrorMessage, onClickPrivacyPolicyToggle, isD2CRegistration } = props;
    const { IsD2CEnabled } = useD2C();
    const { isLoading: isDirectPaymentLoading, email: directPaymentUserEmail } = useHandleDirectPayment();
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [passwordStrength, setPasswordStrength] = useState(false);
    const [showPasswordStrength, setShowPasswordStrength] = useState('');
    const { i18n } = useTranslation();
    const passwordRef1 = useRef();
    const passwordRef2 = useRef();
    const [sessionIdFromUrl, setSessionIdFromUrl] = useState('');
    const [pgIdFromUrl, setPgIdFromUrl] = useState('');
    const [isBillingEmailReadonly, setIsBillingEmailReadonly] = useState(false);
    // const [inputType, setInputType] = useState('password');
    const [inputType, setInputType] = useState({ password: true, confirmPassword: true })
    const togglePassword = useRef(false);
    const subscription = useRef(true);
    const [validUser, setValidUser] = useState(0);
    const [checkingInvitation, setCheckingInvitation] = useState(false);
    const { isAthleteEnabled, isExamineticsEnabled } = useTenantFeatures();

    const checkIsUnderAge = (dob) => {
        if (!dob || !/^\d{2}\/\d{4}$/.test(dob)) return false;
        // eslint-disable-next-line no-unused-vars
        const [month, year] = dob.split('/').map(Number);
        const today = new Date();
        let age = today.getFullYear() - year;
        const m = (today.getMonth() + 1) - month;
        if (m < 0) {
            age--;
        }
        return age < 13;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // const isUnderAge = isAthleteEnabled && checkIsUnderAge(values.dateOfBirth);

    const {
        isNewUserFromDirectPayment,
        setIsNewUserFromDirectPayment,
        clearDirectPaymentState,
    } = useHandleDirectPayment();

    const validationSchema = () => {
        return Yup.object().shape({
            FirstName: Yup.string()
                .required(i18n.t("common.message.error.required-field"))
                .min(2, 'Please enter at least two character'),
            LastName: Yup.string()
                .required(i18n.t("common.message.error.required-field"))
                .min(2, 'Please enter at least two character'),
            // height_feet: Yup.number()
            //     .transform(value => isNaN(value) ? undefined : value)
            //     .required(i18n.t("common.message.error.required-field"))
            //     .integer(i18n.t("common.message.info.height-must-be-digit"))
            //     .moreThan(0, i18n.t("common.message.info.height-feet-must-be-between-1-t0-8"))
            //     .lessThan(9, i18n.t("common.message.info.height-feet-must-be-between-1-t0-8")),
            // height_inch: Yup.number()
            //     .transform(value => isNaN(value) ? undefined : value)
            //     .required(i18n.t("common.message.error.required-field"))
            //     .integer(i18n.t("common.message.info.height-must-be-digit"))
            //     .moreThan(-1, i18n.t("common.message.info.height-inch-must-be-between-0-t0-11"))
            //     .lessThan(12, i18n.t("common.message.info.height-inch-must-be-between-0-t0-11")),
            // Weight: Yup.number()
            //     .transform(value => isNaN(value) ? undefined : value)
            //     .required(i18n.t("common.message.error.required-field"))
            //     .integer(i18n.t("common.message.info.weight-must-be-digit"))
            //     .moreThan(49, i18n.t("common.message.info.weight-must-be-between-50-to-500"))
            //     .lessThan(501, i18n.t("common.message.info.weight-must-be-between-50-to-500")),
            Email: Yup.string()
                .email(i18n.t("common.message.error.invalid-email"))
                .required(i18n.t("common.message.error.required-field")),
            BillingEmail: Yup.string()
                .email(i18n.t("common.message.error.invalid-email"))
                .required(i18n.t("common.message.error.required-field")),
            Password: Yup.string()
                .required(i18n.t("common.message.error.required-field"))
                .matches(/.*[A-Z]/, i18n.t("common.message.info.password-strength-Upper-letter"))
                .matches(/.*[a-z]/, i18n.t("common.message.info.password-strength-Lower-letter"))
                .matches(/.*\d/, i18n.t("common.message.info.password-strength-number"))
                .matches(/.*[\!\@\#\$\%\^\&\*\(\)\-\_\=\+\[\]\{\}\|;:'",<>\?\/\\]/, i18n.t("common.message.info.password-strength-special-character"))
                .min(8, i18n.t("common.message.info.password-strength-alert")),
            ConfirmPassword: Yup.string()
                .required(i18n.t("common.message.error.required-field"))
                .test(
                    'passwords-match',
                    "Password doesn't match",
                    function (value) {
                        return values?.Password === value;
                    }
                ),
            // .oneOf([Yup.ref('Password'), null], `Password doesn't match`),
            TimeZone: Yup.string()
                .required(i18n.t("common.message.error.required-field")),
            AcceptTerms: Yup.bool().oneOf([true], 'Accept Terms & Conditions is required'),
            // Gender: Yup.string()
            //     .required(i18n.t("common.message.error.required-field"))
            //     // .oneOf(['male', 'female']),
            //     .test(
            //         'gender',
            //         "Gender must be male or female",
            //         function(value) {
            //             const genders = ['male', 'female'];
            //             return (values.Gender === "" || genders.includes(values?.Gender)) ? true : false;
            //         }
            //     ),
            // DominantHand: Yup.string()
            //     .required(i18n.t("common.message.error.required-field"))
            //     // .oneOf(['right', 'left']),
            //     .test(
            //         'dominant hand',
            //         "Dominate hand must be right or left",
            //         function(value) {
            //             const dominatHands = ['right', 'left'];
            //             return (values.DominantHand === "" || dominatHands.includes(values?.DominantHand)) ? true : false;
            //         }
            //     ),
        });
    };

    // Helper function to validate a single field
    const validateField = (name, value) => {
        let validationResult;

        switch (name) {
            case 'FirstName':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.FIRST_NAME,
                    answerValidationMessagesConstant.FIRST_AND_LAST_NAME.KEY,
                    value
                );
                return validationResult;

            case 'LastName':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.LAST_NAME,
                    answerValidationMessagesConstant.FIRST_AND_LAST_NAME.KEY,
                    value
                );
                return validationResult;

            case 'Email':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.EMAIL,
                    CONSTANT.ELEMENT_TYPES.EMAIL,
                    value
                );
                return validationResult;

            case 'BillingEmail':
                if (!isAthleteEnabled && !sessionIdFromUrl) return { valid: true, error: null };
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.EMAIL,
                    CONSTANT.ELEMENT_TYPES.EMAIL,
                    value
                );
                return validationResult;

            case 'Password':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.PASSWORD,
                    answerValidationMessagesConstant.PASSWORD.KEY,
                    value
                );
                return validationResult;

            case 'ConfirmPassword':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.CONFIRM_PASSWORD,
                    answerValidationMessagesConstant.CONFIRM_PASSWORD.KEY,
                    { value, password: values.Password }
                );
                return validationResult;

            // case 'height_feet':
            //     validationResult = AnswerValidationService.validate(
            //         CONSTANT.CHATBOT_ACCOUNT.HEIGHT_IN_FEET,
            //         answerValidationMessagesConstant.HEIGHT_FEET.KEY,
            //         value
            //     );
            //     return validationResult;
            //
            // case 'height_inch':
            //     validationResult = AnswerValidationService.validate(
            //         CONSTANT.CHATBOT_ACCOUNT.HEIGHT_IN_INCH,
            //         answerValidationMessagesConstant.HEIGHT_INCH.KEY,
            //         {feet: values['height_feet'], value}
            //     );
            //     return validationResult;

            case 'dateOfBirth':
                if (isExamineticsEnabled) return { valid: true, error: null };
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.DATE_OF_BIRTH,
                    answerValidationMessagesConstant.DATE_OF_BIRTH.KEY,
                    value
                );
                return validationResult;

            // case 'Weight':
            //     validationResult = AnswerValidationService.validate(
            //         CONSTANT.CHATBOT_ACCOUNT.WEIGHT,
            //         answerValidationMessagesConstant.WEIGHT.KEY,
            //         value
            //     );
            //     return validationResult;
            //
            // case 'Gender':
            //     validationResult = AnswerValidationService.validate(
            //         CONSTANT.CHATBOT_ACCOUNT.GENDER_AS_SELECT,
            //         answerValidationMessagesConstant.WEIGHT.KEY,
            //         value
            //     );
            //     return validationResult;
            //
            // case 'DominantHand':
            //     validationResult = AnswerValidationService.validate(
            //         CONSTANT.CHATBOT_ACCOUNT.DOMINANT_HAND_AS_SELECT,
            //         answerValidationMessagesConstant.DOMINANT_HAND_AS_SELECT.KEY,
            //         value
            //     );
            //     return validationResult;

            case 'AcceptTerms':
                validationResult = AnswerValidationService.validate(
                    CONSTANT.CHATBOT_ACCOUNT.TERMS_AND_CONDITIONS,
                    answerValidationMessagesConstant.TERMS_AND_CONDITIONS.KEY,
                    value
                );
                return validationResult;

            case 'UseSameEmailForAthleteAccount':
                // This is an optional checkbox, no validation needed
                return { valid: true, error: null };

            case 'SessionId':
                return { valid: true };

            default:
                break;
        }
    };

    const initialValuesForSignUp = {
        FirstName: "",
        LastName: "",
        // height_feet: "",
        // height_inch: "",
        dateOfBirth: "",
        // Weight: "",
        Email: GLOBAL.URL_PARAMS.EMAIL_ADDRESS ? GLOBAL.URL_PARAMS.EMAIL_ADDRESS : '',
        BillingEmail: '',
        Password: "",
        ConfirmPassword: "",
        HearAboutUs: "",
        // TimeZone: { value: "Eastern Standard Time", label: "(UTC-05:00) Eastern Time (US & Canada)" },
        TimeZone: "Eastern Standard Time",
        AcceptTerms: false,
        UseSameEmailForAthleteAccount: false,
        SessionId: "",
        // Gender: "",
        // DominantHand: "",
    };

    const { handleChange, handleBlur, handleSubmit, setFieldValue, values, errors, touched, isSubmitting, setIsSubmitting } = useForm(initialValuesForSignUp, onSubmitSignUp, validateField);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isUnderAge = isAthleteEnabled && !isExamineticsEnabled && checkIsUnderAge(values.dateOfBirth);

    useEffect(() => {
        const url = window.location.href;
        const params = new URLSearchParams(url.slice(url.indexOf('?')));
        const InvGId = params.get('InvGId') || params.get('invgid');
        const sessionId = params.get('session_id');
        const pgid = params.get('pgid');

        // Set session_id and pgid if both are present in URL
        if (sessionId && pgid) {
            setSessionIdFromUrl(sessionId);
            setPgIdFromUrl(pgid);
            setFieldValue('SessionId', sessionId, false);
            setIsBillingEmailReadonly(true);
        }

        if (InvGId) {
            handleVerifyInvitation(InvGId);
        }

        dispatch(setEventData({ eventName: 'patientPortal_Registration' }))
    }, []);

    useEffect(() => {
        if (directPaymentUserEmail) {
            setFieldIfValid('BillingEmail', directPaymentUserEmail);
        }
    }, [directPaymentUserEmail]);

    const handleClick = e => {
        // noinspection JSUnresolvedFunction
        if (passwordRef1?.current?.contains(e.target)) {
            setPasswordStrength(true);
            return;
        }
        if (!togglePassword.current) {
            setPasswordStrength(false);
        }
        togglePassword.current = false;
    };

    useEffect(() => {
        document.addEventListener("keypress", handleClick);
        document.addEventListener("click", handleClick);

        return () => {
            subscription.current = false;
            document.removeEventListener("keypress", handleClick);
            document.removeEventListener("click", handleClick);
        };
    }, []);


    const passwordStrengthChecker = (e) => {
        e.preventDefault();
        setShowPasswordStrength(e.target.value);
    };

    const onClickChangeInputType = (passwordType) => {
        const passwordTypeCopy = { ...inputType }
        // passwordTypeCopy[passwordType] = !passwordTypeCopy[passwordType];
        setInputType({ ...inputType, [passwordType]: !inputType[passwordType] })
    }


    const handleVerifyEmail = debounce(async (value, errorMessage) => {
        if (errorMessage || !value || checkingInvitation) return;

        setCheckingInvitation(true);
        const payload = { EmailAddress: value, IsD2CRegister: isD2CRegistration }
        const response = await authService.verifyEmail(payload);
        const { data, success, error } = response;
        setCheckingInvitation(false);

        if (!success) {
            // toast.error("Server error: Please try again");
            setErrorMessage(error);
            console.error(error);
            return;
        }
        setErrorMessage('');

        const {
            VerifyStatus,
            InvitationId,
            VerifyStatusText
        } = data || {};

        if (VerifyStatusText === "Registered" && values.BillingEmail) {
            // Set valid user to show the message
            setValidUser(USER_STATUS.REGISTERED);

            // Call props methods if they exist (for backward compatibility)
            if (props?.setEmailToLoadInitiallyAtSignIn) {
                props?.setEmailToLoadInitiallyAtSignIn(value);
                props.handleOnClickAreYouRegistered();
            }

            // Clear direct payment state to prevent redirect loop
            clearDirectPaymentState();

            // Redirect to sign-in with query params using window.location for immediate redirect
            const search = location.search;
            const queryString = search.includes('?') ? search.split('?')[1] : '';
            const params = new URLSearchParams(queryString);
            params.set('redirect_from', 'sign_up');
            // Add BillingEmail as query parameter if it exists
            if (values?.BillingEmail) {
                params.set('billing_email', values.BillingEmail);
            }
            window.location.href = `${routes.signIn}?${params.toString()}`;

            return;
        }

        if (VerifyStatus === USER_STATUS.REGISTERED && props?.setEmailToLoadInitiallyAtSignIn) {
            props?.setEmailToLoadInitiallyAtSignIn(value)
            props.handleOnClickAreYouRegistered();
            return;
        }

        setFieldValues(data, setFieldValue);

        GLOBAL.URL_PARAMS.INVITATION_ID = InvitationId || null;
        setValidUser(VerifyStatus);
        setIsNewUserFromDirectPayment(VerifyStatus === USER_STATUS.D2C_REGISTRATION);
    }, 800);

    const handleVerifyInvitation = async (invitationId) => {
        if (!invitationId) return;

        setCheckingInvitation(true);
        const payload = { InvGId: invitationId }
        const response = await authService.verifyInvitation(payload);
        const { data, success, error } = response;
        setCheckingInvitation(false);

        if (!success) {
            // toast.error("Server error: Please try again");
            setErrorMessage(error);
            console.error(error);
            return;
        }

        // const verifyInvitationDto = new VerifyInvitationDto(data?.EmailAddress, data?.FirstName, data?.LastName, data?.VerifyStatus);

        // if (verifyInvitationDto.FirstName && verifyInvitationDto.LastName && verifyInvitationDto.EmailAddress) {
        //     await setFieldValue('Email', verifyInvitationDto.EmailAddress);
        //     await setFieldValue('FirstName', verifyInvitationDto.FirstName);
        //     await setFieldValue('LastName', verifyInvitationDto.LastName);
        // }

        setFieldValues(data, setFieldValue)

        GLOBAL.URL_PARAMS.INVITATION_ID = invitationId || null;
        setValidUser(data.VerifyStatus);
    };

    const setFieldIfValid = (field, value) => value != null && setFieldValue(field, value);

    const setFieldValues = (data, setFieldValue) => {
        const {
            EmailAddress: email = '',
            FirstName: firstName = '',
            LastName: lastName = '',
            // HeightFeet: heightFeet = 0,
            // HeightInch: heightInch = 0,
            // Weight: weight = 0,
            // Gender: gender = 0,
            // DominantHand: dominantHand = ''
        } = data || {};

        email && setFieldIfValid('Email', email);
        firstName && setFieldIfValid('FirstName', firstName);
        lastName && setFieldIfValid('LastName', lastName);
        // heightFeet > 0 && setFieldIfValid('height_feet', heightFeet);
        // heightInch > 0 && setFieldIfValid('height_inch', heightInch);
        // weight > 0 && setFieldIfValid('Weight', weight);
        //
        // if (gender === 1) {
        //     setFieldValue('Gender', 'male');
        // } else if (gender === 2) {
        //     setFieldValue('Gender', 'female');
        // }
        //
        // dominantHand && setFieldIfValid('DominantHand', (dominantHand || '').toLowerCase());
    };


    const changeFloatToInt = (e, handleBlur, setFieldValue, fieldName) => {
        if (e.target.value == '' || isNaN(e.target.value)) return;
        handleBlur(e);
        const parsedValue = parseFloat(e.target.value.trim());
        const formattedValue = parsedValue.toFixed(0);
        const integerValue = parseInt(formattedValue);
        setFieldValue(fieldName, integerValue);
    }

    const handleOnKeyDown = (e) => {
        if (e.key === 'e' || e.key === '+') {
            e.preventDefault();
        }
    }

    const shouldSignUpBtnDisabled = () => {
        let shouldDisable = false;

        if (isSubmitting) {
            shouldDisable = true;
        } else if (isNewUserFromDirectPayment) {
            shouldDisable = false;
        } else if (validUser === USER_STATUS.REGISTERED) {
            shouldDisable = true;
        } else if (isAthleteEnabled && sessionIdFromUrl) {
            shouldDisable = false;
        } else if (validUser !== USER_STATUS.INVITED && !isD2CRegistration) {
            shouldDisable = true;
        }

        if (!isSubmitting && directPaymentUserEmail) {
            shouldDisable = false;
        }

        return shouldDisable;
    }

    // noinspection CheckTagEmptyBody
    return (
        <div className={`signup_signin_container mmh-flex-wrap ${(IsD2CEnabled && window.location.href.includes('package')) ? " mmh-align-content-start " : " min-height-84-vh mmh-align-content-center"}`}>
            {isDirectPaymentLoading
                ? (
                    <div className="position-center">
                        <i className="fa fa-spinner fa-spin font-size-4-rem"></i>
                    </div>
                ) : (
                    <div>
                        {/* Images at sign up page */}
                        {props?.imgComponent ? props.imgComponent : <div></div>}

                        <div className={`signup_signin_form ${(IsD2CEnabled && window.location.href.includes('package')) ? "padding-1-rem" : ""}`}>
                            {/*<Formik*/}
                            {/*    initialValues={initialValuesForSignUp}*/}
                            {/*    validationSchema={validationSchema()}*/}
                            {/*    onSubmit={onSubmitSignUp}>*/}
                            {/*    {({*/}
                            {/*          handleChange,*/}
                            {/*          handleSubmit,*/}
                            {/*          handleBlur,*/}
                            {/*          values,*/}
                            {/*          errors,*/}
                            {/*          touched,*/}
                            {/*          isSubmitting,*/}
                            {/*          setFieldValue,*/}`
                            {/*          setFieldTouched,*/}
                            {/*          setError,*/}
                            {/*        setValues,*/}
                            {/*        setTouched,*/}
                            {/*          validateForm,*/}
                            {/*          validateField*/}
                            {/*      }) => */}
                            <div>
                                {props?.logoComponent ? props.logoComponent : <div></div>}
                                <div>
                                    <div className="signup_signin_form_header">
                                        {/*<p> New {getUserIdentification()} Registration </p>*/}
                                        <p>Create Account</p>
                                    </div>

                                    {/*<PackageSmallDetails />*/}

                                    <div className="margin-bottom-1-rem">
                                        {validUser === USER_STATUS.NOT_FOUND && !isAthleteEnabled && (
                                            <div className="signup-alert signup-alert-danger" role="alert">
                                                <div className="alert-text">Public registration is disabled for now, Please contact
                                                    with your {isExamineticsEnabled ? 'employer' : 'provider'}.
                                                </div>
                                            </div>
                                        )}
                                        {validUser === USER_STATUS.REGISTERED && (
                                            <div className="signup-alert signup-alert-danger" role="alert">
                                                <p className="alert-text error-message">
                                                    You’re a registered user, please log in with your email and password.
                                                </p>
                                            </div>
                                        )}
                                        {validUser === USER_STATUS.INVITED && (
                                            <div className="signup-alert signup-alert-success" role="alert">
                                                <div className="alert-text">You have been invited to register by your {isExamineticsEnabled ? 'employer' : 'provider'}.
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <form className="position-relative" onSubmit={handleSubmit}>
                                        {/*<form className={`${checkingInvitation ? "blurry pointer-none cursor-not-allowed " : ""}`} onSubmit={handleSubmit}>*/}
                                        <div>
                                            <p className={`z-10 position-center font-bold color-primary font-size-md ${checkingInvitation ? " display-block " : " display-none "}`}>Verifying your invitation please wait...</p>
                                            <div className={`${checkingInvitation ? "blurry pointer-none cursor-not-allowed " : ""}`}>
                                                {isAthleteEnabled && sessionIdFromUrl && pgIdFromUrl && (
                                                    <>
                                                        <div className="marginBottom2rem">
                                                            <label className="signup_signin_input-label">Card Holder E-mail</label>
                                                            <div className="sign-up-password-input-container input-with-icon input-right">
                                                                <span className="input-icon-left">
                                                                    <span>
                                                                        <i className="far fa-envelope sign-up-icon"></i>
                                                                    </span>
                                                                </span>
                                                                <input
                                                                    className={`sign-up-password-input ${directPaymentUserEmail || isBillingEmailReadonly ? 'disabled-input' : ''}`}
                                                                    type="email"
                                                                    placeholder="Enter email address"
                                                                    name="BillingEmail"
                                                                    autoComplete="off"
                                                                    disabled={!!directPaymentUserEmail || isBillingEmailReadonly}
                                                                    onChange={async (e) => {
                                                                        await handleChange(e);
                                                                        // If checkbox is checked, sync the Email field
                                                                        if (values.UseSameEmailForAthleteAccount) {
                                                                            await setFieldValue('Email', e.target.value);
                                                                        }
                                                                    }}
                                                                    onBlur={async (e) => {
                                                                        await handleBlur(e);
                                                                    }}
                                                                    value={values?.BillingEmail}
                                                                />
                                                            </div>
                                                            {errors.BillingEmail && touched.BillingEmail && (
                                                                <div className="sign-up-error-msg">{errors.BillingEmail}</div>
                                                            )}
                                                        </div>
                                                        <div className="padding-left-0-rem displayFlex flex-direction-column margin-bottom-10-px">
                                                            <label className="signup-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    name="UseSameEmailForAthleteAccount"
                                                                    onClick={async (e) => {
                                                                        await handleChange(e);
                                                                        // When checked, copy BillingEmail to Email and verify
                                                                        if (e.target.checked) {
                                                                            await setFieldValue('Email', values.BillingEmail);
                                                                            // Trigger email verification if BillingEmail has a value and format is valid
                                                                            if (values.BillingEmail) {
                                                                                const validationResult = validateField('Email', values.BillingEmail);
                                                                                if (validationResult && validationResult.valid) {
                                                                                    await handleVerifyEmail(values.BillingEmail, null);
                                                                                }
                                                                            }
                                                                        }
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    value={values.UseSameEmailForAthleteAccount}
                                                                    checked={values.UseSameEmailForAthleteAccount} />
                                                                <div className="signup-terms-text">Use the cardholder’s email as the login email.
                                                                </div>
                                                            </label>
                                                        </div>
                                                    </>
                                                )}
                                                <div className="marginBottom2rem">
                                                    <label className="signup_signin_input-label">{sessionIdFromUrl && isAthleteEnabled && 'Sign-in'} E-mail</label>
                                                    <div className="sign-up-password-input-container input-with-icon input-right">
                                                        <span className="input-icon-left">
                                                            <span>
                                                                <i className="far fa-envelope sign-up-icon"></i>
                                                            </span>
                                                        </span>
                                                        <input
                                                            className={`sign-up-password-input ${values.UseSameEmailForAthleteAccount ? 'disabled-input' : ''}`}
                                                            type="email"
                                                            placeholder="Enter email address"
                                                            name="Email"
                                                            autoComplete="off"
                                                            disabled={values.UseSameEmailForAthleteAccount}
                                                            onChange={handleChange}
                                                            onBlur={async (e) => {
                                                                const emailValue = e.target.value;
                                                                // Only verify if email format is valid
                                                                const validationResult = validateField('Email', emailValue);
                                                                if (validationResult && validationResult.valid) {
                                                                    await handleVerifyEmail(emailValue, null);
                                                                }
                                                            }}
                                                            value={values?.Email}
                                                        />
                                                    </div>
                                                    {errors.Email && touched.Email && (
                                                        <div className="sign-up-error-msg">{errors.Email}</div>
                                                    )}

                                                    {errorMessage && (
                                                        <div className="signup-login-account">
                                                            <span className="signup-login-account-msg error-text">
                                                                {errorMessage}
                                                            </span>
                                                        </div>
                                                    )}

                                                    {/*{checkingInvitation && (*/}
                                                    {/*    <div className="padding-left-15 font-sm success-text">*/}
                                                    {/*        Verifying your invitation*/}
                                                    {/*    </div>*/}
                                                    {/*)}*/}
                                                </div>


                                                <div className="marginBottom2rem">
                                                    <div className="sign-up-name-container">
                                                        <div className="signup_signin_input-container">
                                                            <label className="signup_signin_input-label">First Name</label>
                                                            <input
                                                                className={`signin_input-field color-primary-dark-2`}
                                                                type="text"
                                                                placeholder="Enter first name"
                                                                name="FirstName"
                                                                autoComplete="off"
                                                                onChange={handleChange}
                                                                maxLength='30'
                                                                onBlur={handleBlur}
                                                                value={values.FirstName}
                                                            />
                                                            {errors.FirstName && touched.FirstName && (
                                                                <div className="name-error-msg">{errors.FirstName}</div>
                                                            )}
                                                        </div>
                                                        <div className="signup_signin_input-container">
                                                            <label className="signup_signin_input-label">Last Name</label>
                                                            <input
                                                                className={`signin_input-field color-primary-dark-2`}
                                                                type="text"
                                                                placeholder="Enter last name"
                                                                name="LastName"
                                                                autoComplete="off"
                                                                onChange={handleChange}
                                                                maxLength='25'
                                                                onBlur={handleBlur}
                                                                value={values.LastName}
                                                            />
                                                            {errors.LastName && touched.LastName && (
                                                                <div className="name-error-msg">{errors.LastName}</div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/*    <div className="marginBottom2rem">*/}
                                                {/*        <div className="sign-up-name-container">*/}
                                                {/*            <div className="signup_signin_input-container marginright">*/}
                                                {/*                <label className="signup_signin_input-label">Height</label>*/}
                                                {/*                <input*/}
                                                {/*                    className={`signin_input-field color-primary-dark-2`}*/}
                                                {/*                    type="number"*/}
                                                {/*                    placeholder="Feet"*/}
                                                {/*                    name="height_feet"*/}
                                                {/*                    autoComplete="off"*/}
                                                {/*                    onChange={handleChange}*/}
                                                {/*                    onBlur={(e) => {*/}
                                                {/*                        changeFloatToInt(e, handleBlur, setFieldValue, 'height_feet');*/}
                                                {/*                    }}*/}
                                                {/*                    onKeyDown={handleOnKeyDown}*/}
                                                {/*                    value={values.height_feet}*/}
                                                {/*                    min="1"*/}
                                                {/*                    max="8"*/}
                                                {/*                />*/}
                                                {/*                <div></div>*/}
                                                {/*                {errors.height_feet && touched.height_feet && (*/}
                                                {/*                    <div className="name-error-msg">{errors.height_feet}</div>*/}
                                                {/*                )}*/}
                                                {/*            </div>*/}
                                                {/*            <div className="signup_signin_input-container marginright">*/}
                                                {/*                <label className="signup_signin_input-label">&nbsp;</label>*/}
                                                {/*                <input*/}
                                                {/*                    className={`signin_input-field color-primary-dark-2`}*/}
                                                {/*                    type="number"*/}
                                                {/*                    placeholder="Inch"*/}
                                                {/*                    name="height_inch"*/}
                                                {/*                    autoComplete="off"*/}
                                                {/*                    onChange={handleChange}*/}
                                                {/*                    // onBlur={handleBlur}*/}
                                                {/*                    onBlur={(e) => {*/}
                                                {/*                        changeFloatToInt(e, handleBlur, setFieldValue, 'height_inch');*/}
                                                {/*                    }}*/}
                                                {/*                    onKeyDown={handleOnKeyDown}*/}
                                                {/*                    value={values.height_inch}*/}
                                                {/*                    min="0"*/}
                                                {/*                    max="11"*/}
                                                {/*                />*/}
                                                {/*                <div></div>*/}
                                                {/*                {errors.height_inch && touched.height_inch && (*/}
                                                {/*                    <div className="name-error-msg">{errors.height_inch}</div>*/}
                                                {/*                )}*/}
                                                {/*            </div>*/}
                                                {/*            <div className="signup_signin_input-container marginright">*/}
                                                {/*                <label className="signup_signin_input-label">&nbsp;</label>*/}
                                                {/*                <input*/}
                                                {/*                    readOnly={true}*/}
                                                {/*                    className={`signin_input-field color-primary-dark-2`}*/}
                                                {/*                    type="number"*/}
                                                {/*                    placeholder="Enter Height(Inch.)"*/}
                                                {/*                    autoComplete="off"*/}
                                                {/*                    //onChange={handleChange}*/}
                                                {/*                    //onBlur={handleBlur}*/}
                                                {/*                    value={+values.height_feet * 12 + +values.height_inch}*/}
                                                {/*                />*/}
                                                {/*                <div></div>*/}
                                                {/*                /!* {errors.height_inch && touched.height_inch && (*/}
                                                {/*    <div className="name-error-msg">{errors.height_inch}</div>*/}
                                                {/*)} *!/*/}
                                                {/*            </div>*/}
                                                {/*        </div>*/}
                                                {/*    </div>*/}
                                                {!isExamineticsEnabled && (
                                                    <div className="marginBottom2rem">
                                                        <div className="sign-up-name-container">
                                                            <div className="signup_signin_input-container">
                                                                <label className="signup_signin_input-label">Birth Month & Year</label>
                                                                {/*<input*/}
                                                                {/*    className={`signin_input-field color-primary-dark-2`}*/}
                                                                {/*    type="date"*/}
                                                                {/*    placeholder="Enter your date of birth"*/}
                                                                {/*    name="dateOfBirth"*/}
                                                                {/*    autoComplete="off"*/}
                                                                {/*    onChange={handleChange}*/}
                                                                {/*    onBlur={(e) => {*/}
                                                                {/*        changeFloatToInt(e, handleBlur, setFieldValue, 'dateOfBirth');*/}
                                                                {/*    }}*/}
                                                                {/*    value={values.dateOfBirth}*/}
                                                                {/*    onKeyDown={handleOnKeyDown}*/}
                                                                {/*/> */}
                                                                <InputMask
                                                                    mask="99/9999"
                                                                    maskChar="_"
                                                                    className={`signin_input-field color-primary-dark-2`}
                                                                    type="text"
                                                                    name="dateOfBirth"
                                                                    placeholder="MM/YYYY"
                                                                    value={values.dateOfBirth}
                                                                    onChange={handleChange}
                                                                    onBlur={(e) => {
                                                                        if (!e.target.value || !/\d/.test(e.target.value)) return;
                                                                        handleBlur(e);
                                                                    }}
                                                                />
                                                                {errors.dateOfBirth && touched.dateOfBirth && (
                                                                    <div className="name-error-msg">{errors.dateOfBirth}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {isUnderAge && (
                                                    <div className="signup-alert" style={{ width: 'auto', maxWidth: 'full', boxSizing: 'border-box', backgroundColor: '#fff3cd', color: '#856404', borderColor: '#ffeeba', display: 'flex', alignItems: 'flex-start', padding: '1rem', borderRadius: '4px', marginBottom: '2rem' }}>
                                                        <i className="fas fa-exclamation-triangle" style={{ marginRight: '10px', marginTop: '3px' }}></i>
                                                        <div className="alert-text" style={{ fontSize: '0.9rem' }}>
                                                            Individuals under the age of 13 are prohibited from registering for Atlas Athlete.
                                                            For more information, reach out to <a href="mailto:support@atlasathlete.ai" style={{ fontWeight: 'bold', textDecoration: 'underline', color: '#856404' }}>support@atlasathlete.ai</a>
                                                        </div>
                                                    </div>
                                                )}

                                                {!isUnderAge && (
                                                    <>

                                                        {/*<div className="marginBottom2rem">*/}
                                                        {/*    <div className="sign-up-name-container">*/}
                                                        {/*        <div className="signup_signin_input-container marginleft">*/}
                                                        {/*            <label className="signup_signin_input-label">Weight</label>*/}
                                                        {/*            <input*/}
                                                        {/*                className={`signin_input-field color-primary-dark-2`}*/}
                                                        {/*                type="number"*/}
                                                        {/*                placeholder="Enter Weight(LBS)"*/}
                                                        {/*                name="Weight"*/}
                                                        {/*                autoComplete="off"*/}
                                                        {/*                onChange={handleChange}*/}
                                                        {/*                onBlur={(e) => {*/}
                                                        {/*                    changeFloatToInt(e, handleBlur, setFieldValue, 'Weight');*/}
                                                        {/*                }}*/}
                                                        {/*                value={values.Weight}*/}
                                                        {/*                onKeyDown={handleOnKeyDown}*/}
                                                        {/*            />*/}
                                                        {/*            {errors.Weight && touched.Weight && (*/}
                                                        {/*                <div className="name-error-msg">{errors.Weight}</div>*/}
                                                        {/*            )}*/}
                                                        {/*        </div>*/}
                                                        {/*    </div>*/}
                                                        {/*</div>*/}

                                                        {/*<div className="marginBottom2rem">*/}
                                                        {/*    <div className="sign-up-name-container">*/}
                                                        {/*        <div className="signup_signin_input-container marginright">*/}
                                                        {/*            <label className="signup_signin_input-label">Gender</label>*/}
                                                        {/*            <select*/}
                                                        {/*                className={`${!values.Gender ? "color-secondary": "color-primary-dark-2"} signin_input-field `}*/}
                                                        {/*                name="Gender"*/}
                                                        {/*                onChange={handleChange}*/}
                                                        {/*                onBlur={handleBlur}*/}
                                                        {/*                value={values.Gender}*/}
                                                        {/*            >*/}
                                                        {/*                <option value="" disabled selected>Select gender</option>*/}
                                                        {/*                <option value="male">Male</option>*/}
                                                        {/*                <option value="female">Female</option>*/}
                                                        {/*            </select>*/}
                                                        {/*            {errors.Gender && touched.Gender && (*/}
                                                        {/*                <div className="name-error-msg">{errors.Gender}</div>*/}
                                                        {/*            )}*/}
                                                        {/*        </div>*/}

                                                        {/*        <div className="signup_signin_input-container marginleft">*/}
                                                        {/*            <label className="signup_signin_input-label">Dominant Hand</label>*/}
                                                        {/*            <select*/}
                                                        {/*                className={`${!values.DominantHand ? "color-secondary": "color-primary-dark-2"} signin_input-field`}*/}
                                                        {/*                name="DominantHand"*/}
                                                        {/*                onChange={handleChange}*/}
                                                        {/*                onBlur={handleBlur}*/}
                                                        {/*                value={values.DominantHand}*/}
                                                        {/*            >*/}
                                                        {/*                <option value="" disabled selected>Select dominant hand</option>*/}
                                                        {/*                <option value="left">Left</option>*/}
                                                        {/*                <option value="right">Right</option>*/}
                                                        {/*            </select>*/}
                                                        {/*            {errors.DominantHand && touched.DominantHand && (*/}
                                                        {/*                <div className="name-error-msg">{errors.DominantHand}</div>*/}
                                                        {/*            )}*/}
                                                        {/*        </div>*/}
                                                        {/*    </div>*/}
                                                        {/*</div>*/}

                                                        {/*<div className="marginBottom2rem">*/}
                                                        {/*    <label className="signup_signin_input-label">E-mail</label>*/}
                                                        {/*    <div className="input-with-icon sign-up-password-input-container input-right">*/}
                                                        {/*        <span className="input-icon-left">*/}
                                                        {/*            <span>*/}
                                                        {/*                <i className="far fa-envelope sign-up-icon"></i>*/}
                                                        {/*            </span>*/}
                                                        {/*        </span>*/}
                                                        {/*        <input*/}
                                                        {/*            className={`mt-0 sign-up-password-input`}*/}
                                                        {/*            type="email"*/}
                                                        {/*            disabled={!!GLOBAL.URL_PARAMS.EMAIL_ADDRESS}*/}
                                                        {/*            placeholder="Enter your email address"*/}
                                                        {/*            name="Email"*/}
                                                        {/*            autoComplete="off"*/}
                                                        {/*            onChange={(e) => {*/}
                                                        {/*                handleChange(e);*/}
                                                        {/*                handleVerifyEmail(e.target['value'], errors?.Email);*/}
                                                        {/*            }}*/}
                                                        {/*            onBlur={handleBlur}*/}
                                                        {/*            onKeyUp={(e) => handleVerifyEmail(e.target['value'], errors?.Email)}*/}
                                                        {/*            value={values.Email}*/}
                                                        {/*        />*/}
                                                        {/*    </div>*/}
                                                        {/*    {errors.Email && touched.Email && (*/}
                                                        {/*        <div className="sign-up-error-msg">{errors.Email}</div>*/}
                                                        {/*    )}*/}
                                                        {/*    {checkingInvitation && (*/}
                                                        {/*        <div className="padding-left-15 font-sm success-text">*/}
                                                        {/*            Verifying your invitation*/}
                                                        {/*        </div>*/}
                                                        {/*    )}*/}
                                                        {/*</div>*/}

                                                        <div className="marginBottom2rem">
                                                            <div className="sign-up-name-container">
                                                                <div className="signup_signin_input-container">
                                                                    <label className="signup_signin_input-label">Password</label>
                                                                    <div className="sign-up-password-input-container input-with-icon input-right">
                                                                        <span className="input-icon-left">
                                                                            <span>
                                                                                <i className="fas fa-lock sign-up-icon margin-right-0-75rem"></i>
                                                                            </span>
                                                                        </span>
                                                                        <input
                                                                            className={`sign-up-password-input color-primary-dark-2`}
                                                                            ref={passwordRef1}
                                                                            type={inputType.password ? "password" : "text"}
                                                                            placeholder="Enter Password"
                                                                            name="Password"
                                                                            autoComplete="off"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.Password}
                                                                            onKeyUp={(e) => passwordStrengthChecker(e)}
                                                                        />
                                                                        <span className="input-icon-right">
                                                                            <span>
                                                                                {(values.Password && inputType.password) && (
                                                                                    <i onClick={() => onClickChangeInputType("password")} className="fa fa-eye sign-up-icon" />
                                                                                )}
                                                                                {(values.Password && !inputType.password) && (
                                                                                    <i onClick={() => onClickChangeInputType("password")} className="fa fa-eye-slash sign-up-icon" />
                                                                                )}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    {errors.Password && touched.Password && (
                                                                        <div className="sign-up-error-msg">
                                                                            {errors.Password}
                                                                        </div>
                                                                    )}
                                                                    {passwordStrength && showPasswordStrength && (
                                                                        <PasswordStrengthChecker password={showPasswordStrength} />
                                                                    )}
                                                                </div>
                                                                <div className="signup_signin_input-container">
                                                                    <label className="signup_signin_input-label">Confirm Password</label>
                                                                    <div className="sign-up-password-input-container input-with-icon input-right">
                                                                        <span className="input-icon-left">
                                                                            <span>
                                                                                <i className="fas fa-lock sign-up-icon mr-3"></i>
                                                                            </span>
                                                                        </span>
                                                                        <input
                                                                            className={`sign-up-password-input color-primary-dark-2`}
                                                                            ref={passwordRef2}
                                                                            type={inputType.confirmPassword ? "password" : "text"}
                                                                            placeholder="Enter confirmed password"
                                                                            name="ConfirmPassword"
                                                                            autoComplete="off"
                                                                            onChange={handleChange}
                                                                            onBlur={handleBlur}
                                                                            value={values.ConfirmPassword}
                                                                        />

                                                                        <span className="input-icon-right">
                                                                            <span>
                                                                                {values.ConfirmPassword && inputType.confirmPassword && (
                                                                                    <i onClick={() => onClickChangeInputType("confirmPassword")} className="fa fa-eye sign-up-icon" />
                                                                                )}
                                                                                {(values.ConfirmPassword && (!inputType.confirmPassword)) && (
                                                                                    <i onClick={() => onClickChangeInputType("confirmPassword")} className="fa fa-eye-slash sign-up-icon" />
                                                                                )}
                                                                            </span>
                                                                        </span>
                                                                    </div>
                                                                    {(errors.ConfirmPassword && touched.ConfirmPassword) && (
                                                                        <div className="sign-up-error-msg">
                                                                            {errors.ConfirmPassword}
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="extra-login-info">
                                                            <div className="padding-left-0-rem displayFlex flex-direction-column">
                                                                <label className="signup-checkbox">
                                                                    <input
                                                                        className={invalidFormElement(
                                                                            "AcceptTerms",
                                                                            errors,
                                                                            values,
                                                                            touched
                                                                        )}
                                                                        type="checkbox"
                                                                        name="AcceptTerms"
                                                                        // onChange={handleChange}
                                                                        onClick={handleChange}
                                                                        onBlur={handleBlur}
                                                                        value={values.AcceptTerms}
                                                                        checked={values.AcceptTerms} />
                                                                    <div className="signup-terms-text">I agree the&nbsp;
                                                                        <a href={"!#"}
                                                                            rel="noopener noreferrer">
                                                                            <span className="signup-link font-bold" onClick={onClickTermOfServiceToggle}>Terms and Conditions</span>/
                                                                            <span className="signup-link font-bold" onClick={onClickPrivacyPolicyToggle}> Privacy Policy</span>
                                                                        </a>
                                                                    </div>
                                                                </label>
                                                                {errors.AcceptTerms && touched.AcceptTerms && (
                                                                    <div className="name-error-msg font-bold" style={{ marginTop: '0.5rem' }}>{errors.AcceptTerms}</div>
                                                                )}
                                                            </div>
                                                        </div>
                                                        <div className="marginBottom2rem signup_signin_submit_wrapper">
                                                            <button
                                                                type="submit"
                                                                className="signup_signin_submit"
                                                                disabled={shouldSignUpBtnDisabled()}
                                                            >
                                                                {isSubmitting ? (
                                                                    <>
                                                                        <i className="fa fa-spinner fa-spin" />&nbsp;&nbsp;
                                                                        <Trans i18nKey="common.message.info.please-wait" />
                                                                    </>
                                                                ) : (
                                                                    // i18n.t("common.form.sign-up")
                                                                    <>Submit</>
                                                                )}
                                                            </button>
                                                            {/*{errorMessage && (*/}
                                                            {/*    <div className="signup-login-account">*/}
                                                            {/*        <span className="signup-login-account-msg text-danger">*/}
                                                            {/*            {errorMessage}*/}
                                                            {/*        </span>*/}
                                                            {/*    </div>*/}
                                                            {/*)}*/}
                                                            {/*{signUpCreated && (*/}
                                                            {/*    <div className="signup-login-account">*/}
                                                            {/*<span className="signup-login-account-msg text-success">*/}
                                                            {/*    <Trans*/}
                                                            {/*        i18nKey="common.message.success.registration" />*/}
                                                            {/*</span>*/}
                                                            {/*    </div>*/}
                                                            {/*)}*/}
                                                        </div>
                                                    </>
                                                )}
                                            </div>

                                        </div>
                                    </form>
                                </div>
                            </div>
                            {/*}</Formik>*/}
                            {!isUnderAge && (
                                <div className="signup_signin_registered">
                                    {props.children}
                                </div>
                            )}
                        </div>
                    </div >
                )
            }
        </div >
    );
}

export default SignUp1;
